<template>
    <div class="row" style="margin-top:5em;">
        <div class="col-12 col-lg-8 mb-5">
            <h1 class="text-white class-title"><img class="mc-blue-arrow d-none d-md-inline" src="/img/MC_arrow_blue.svg"/>{{mclass.Name__c}}</h1>
            <div class='embed-container' :class="(preview||(!loading&&!needs_login&&!mclass.needs_register)) ? '' : 'd-none'">
                <template v-if="this.mclass.Content_Details_JSON__c.trailer_url">
                    <iframe ref="iframe" :src="'https://player.vimeo.com/video/'+loadStartVideo()" frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                </template>
                <template v-if="!this.mclass.Content_Details_JSON__c.trailer_url">
                    <iframe ref="iframe" src="https://player.vimeo.com/video/13473425" frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                </template>
            </div>
            <div class="w-50 m-auto p-5" v-if="!current_session && !mclass.enrolled && needs_login && !mclass.auth">
                <h3 class="text-white text-center">You need to login first</h3>
                <label class="text-white"> Email </label>
                <input type="text" name="" @change="setEmail($event.target.value)" class="form-control">
                <label class="text-white"> Zip </label>
                <input type="text" name="" @change="setZip($event.target.value)" class="form-control">
                <br>
                <button style="font-size: xx-large;" @click.prevent="login" class="m-auto btn btn-primary btn-block w-50"><img src="/img/MC_arrow_orange.svg" style="height: 25px;" /> Login </button>

                <div class="mt-2 w-100 text-center">
                    <a data-ac-button="{}" :href="CMS_URL+'/common/forms/ajax_form/'+mclass.OneForm_ID__c">New User?</a>
                </div>
            </div>

            <div class="register-now m-auto p-5" v-if="mclass.needs_register && mclass.auth && !preview">
                <h2 class="text-white text-center"> You are not registered for this class.</h2>
                <a class="m-auto btn btn-info btn-block w-50" :data-ac-button="ac_opts" :href="CMS_URL+'/common/forms/ajax_form/'+mclass.OneForm_ID__c">Register Now</a>
            </div>

            <Spinner color="white" :height="80" :width="80" class="text-white" v-if="loading" />

            <Complete :link="link" :class-name="mclass.Name__c" v-if="completed"/>

        </div>
        <div class="col-10 ml-4 ml-lg-0 col-lg-4 mt-3">
            <p class="ml-3 text-white mt-2 mt-lg-0"> Sponsored By </p>

            <span v-for="sponsor in mclass.Sponsor" :key="sponsor.Id">
                <a v-if="sponsor.Sponsor_Logo_Link__c" :href="sponsor.Sponsor_Logo_Link__c" target="_blank">
                    <img v-if="typeof sponsor.Logo__c != 'undefined' && sponsor.Logo__c != null" :src="sponsor.Logo__c" class="mt-2 ml-3 img-fluid img-thumbnail">
                    <h4 class="text-info ml-3" v-if="typeof sponsor.Logo__c == 'undefined' || sponsor.Logo__c == null">{{ sponsor.Name__c }}</h4>
                </a>
                <template v-if="!sponsor.Sponsor_Logo_Link__c">
                    <img v-if="typeof sponsor.Logo__c != 'undefined' && sponsor.Logo__c != null" :src="sponsor.Logo__c" class="mt-2 ml-3 img-fluid img-thumbnail">
                    <h4 class="text-info ml-3" v-if="typeof sponsor.Logo__c == 'undefined' || sponsor.Logo__c == null">{{ sponsor.Name__c }}</h4>
                </template>
            </span>

            <ul class="ml-3 no-list-style search-list mb-2">
                <li style="position: relative;border-bottom: none;" class="pt-2 pl-1">
                    <a class="topic-link" @click.prevent="setOverview()" href="#overview">Class Overview</a>
                    <img v-if="overview" src="/img/MC_arrow_orange.svg" style="height: 35px; position: absolute; left: -30px; top: 3px;" />
                </li>
            </ul>

            <a v-if="!needs_login && mclass.enrolled" class="btn btn-gt ml-3 mt-2 mb-2" @click.prevent="startClass()" href="#overview">Start Class</a>
            <a v-if="needs_login || !mclass.enrolled" class="btn btn-gt ml-3 mt-2 mb-2" :data-ac-button="ac_opts" :href="CMS_URL+'/common/forms/ajax_form/'+mclass.OneForm_ID__c">Start Class</a>

            <br>

            <span class="gt-orange ml-3" style="font-size: x-large;">Lessons</span>
            <ul class="ml-3 no-list-style search-list">
                <li v-for="(session,id,i) in mclass.Session" :key="session.Id" style="position: relative;" class="pt-2">
                    <img v-if="current_session == session.Id" src="/img/MC_arrow_orange.svg" style="height: 35px; position: absolute; left: -30px; top: 5px;" />
                    <span v-if="mclass.auth" class="text-white" :sf="id">{{ (isNaN(i)) ? id+1 : i+1}}.&nbsp;</span>
                    <span v-if="!mclass.auth" class="text-white">{{id+1}}.&nbsp;</span>

                    <a v-if="!needs_login && mclass.enrolled" class="topic-link" @click.prevent="set(session)" :href="'#'+session.Id">{{session.Name__c}}</a>
                    <a v-if="needs_login || !mclass.enrolled" class="topic-link" :data-ac-button="ac_opts" :href="CMS_URL+'/common/forms/ajax_form/'+mclass.OneForm_ID__c">{{session.Name__c}}</a>

                    <small style="" class="text-success ml-1">
                        ({{(typeof session.Status != 'undefined' && typeof session.Status.Complete_Pct__c != 'undefined') ? session.Status.Complete_Pct__c.toFixed(1) : '0.0' }}%)
                    </small>

                </li>
            </ul> 
        </div>
    </div>
</template>

<script>
import Player from '@vimeo/player';
import Spinner from './Spinner';
import Complete from './Complete';
import { apiCall } from '../utils/utils';
import ConfettiGenerator from "confetti-js";

export default {
    name: 'MasterClass',
    components:{
        Spinner,
        Complete
    },
    props: {
        msg: String
    },
    data: function(){
        return {
            mclass: window.CLASS,
            player: false,
            sessionDescription: '',
            converted_urls: {},
            loading: true,
            observer: null,
            current_session: false,
            needs_login: false,
            preview: true,
            ac_opts: "{}",
            last_position: 0,
            completed: false,
            confetti: null,
            link: "#",
            CMS_URL: window.CMS_URL,
            completed_sessions: [],
            overview: true
        }
    },
    mounted: function() {
        // const self = this

        // Preload URL IDs so we don't affect UX when links are clicked
        Object.keys(this.mclass.Session).forEach((session_ix)=>{
            const session = this.mclass.Session[session_ix];
            this.converted_urls[session.Id] = this.GetVimeoIDbyUrl(session.Video_URL__c);  
        });

        if(this.mclass.auth) {
            this.ac_opts = JSON.stringify({
                email: this.mclass.email,
                zip: this.mclass.zip,
                directForm: true
            })
        }
        if(this.mclass.class_complete) {
            this.completed = true;
            if(this.link == '#') {
                this.link = '/renderCertificate?class='+this.mclass.Id+'&student='+this.mclass.Student.Id;
            }
        }

        this.player = new Player(this.$refs.iframe);
        this.player.on('loaded',() => {
            this.loading = false;
        });
        this.player.on('ended',() => {
            this.advanceToNextSession()
        });

        setInterval(() => {
            // Check if complete every 2 seconds
            if(this.current_session) {
                this.completeCheck();
            }
        },2000);

        setInterval(() => {
            // Update something every 10 seconds
            if(this.current_session) {
                this.find();
            }
        },10000);

        if (window.location.hash.length) {
            const session_id = window.location.hash.replace('#', '');
            if (typeof this.mclass.Session[session_id] !== 'undefined') {
                this.set(this.mclass.Session[session_id]);
            }
        }

        const urlParams = new URLSearchParams(window.location.search);
        const session_id = urlParams.get('session');

        if( session_id != null ){
            this.set(this.mclass.Session[session_id])
            urlParams.delete('session');
            window.history.replaceState({}, '', `${window.location.pathname}`+'#'+session_id)
        }

        

        window.postClassRegister = function(data){
            window.location = '/registerLogin?email='+data.email+'&zip='+data.zip+'&class_id='+data.class_id;
        }

    },
    methods: {
        loadStartVideo() {
            if( this.mclass.Content_Details_JSON__c.trailer_url ) {
                return this.GetVimeoIDbyUrl(this.mclass.Content_Details_JSON__c.trailer_url);
            } else {
                return ''
            }
        },
        setOverview() {
            document.getElementById('ClassOverview').style.display = 'block';
            document.getElementById('SessionDetails').style.display = 'none';
            document.getElementById('SessionDetailText').innerHTML = '';
            this.overview = true;
            this.current_session = false;
            // const self = this;
            let vimeoVideo = this.GetVimeoIDbyUrl(this.mclass.Content_Details_JSON__c.trailer_url);
            if( !vimeoVideo ) {
                vimeoVideo = 'https://player.vimeo.com/video/13473425';
            }
            this.player.unload().then(() => {
                this.player.loadVideo(vimeoVideo);
            });
            this.revealAllSpeakers();
        },
        revealAllSpeakers() {
            const speakers = document.querySelectorAll('[data-sessions]');
            for (let i in speakers) {
                if( typeof speakers[i].style !== 'undefined' ) {
                    speakers[i].style.display = 'flex';
                }
            }
        },
        sessionDetails(session) {
            console.log(session);
            if (session.Description__c != 'null' && session.Description__c != '' && session.Description__c != '<p><br></p>' && session.Description__c != null) {
                document.getElementById('ClassOverview').style.display = 'none';
                document.getElementById('SessionDetails').style.display = 'block';
                document.getElementById('SessionDetailText').innerHTML = session.Description__c;
                const speakers = document.querySelectorAll('[data-sessions]');
                for (let i in speakers) {
                    if( typeof speakers[i].getAttribute !== 'undefined' ) {
                        if (speakers[i].getAttribute('data-sessions').indexOf(session.Id) === -1) {
                            speakers[i].style.display = 'none';
                        } else {
                            speakers[i].style.display = 'flex';
                        }
                    }
                }
            } else {
                this.revealAllSpeakers();
                this.setOverview();
            }
            this.overview = false;
        },
        startClass() {
            var first_key = Object.keys(this.mclass.Session)[0];
            this.set(this.mclass.Session[first_key]);
        },
        complete() {

            if(!this.completed){
                var confettiSettings = {"target":"confetti-holder","max":"220","size":"1","animate":true,"props":["circle","square","triangle"],"colors":[[165,104,246],[230,61,135],[0,199,228],[253,214,126]],"clock":"25","rotate":false,"width":"1920","height":"1022","start_from_edge":false,"respawn":true};
                this.confetti = new ConfettiGenerator(confettiSettings);

                this.confetti.render();

                setTimeout(()=>{
                    this.confetti.clear();
                },10000);

                apiCall('/session/sendCertificate/'+this.mclass.Id+"?student="+this.mclass.Student.Id)

            }
            if(this.link == '#') {
                this.link = '/renderCertificate?class='+this.mclass.Id+'&student='+this.mclass.Student.Id;
            }

            this.completed = true;
        },
        find(){
            //const self = this;
            if(this.current_session != false){


                this.player.getCurrentTime().then((seconds) => {
                    // Update Current Position
                    if( seconds != this.last_position ){

                        this.last_position = seconds;

                        apiCall('/session/update/'+this.current_session,'POST',{
                            position: seconds,
                            class_id: this.mclass.Id,
                            student: this.mclass.Student
                        })
                        .then( (e) => {
                            return e.json();
                        })
                        .then((data)=>{
                            this.mclass.Session[this.current_session] = { ...this.mclass.Session[this.current_session], Status : data };
                            if(this.mclass.Session[this.current_session].Status.Status_JSON__c.Complete_Pct__c > 90){
                                this.completeCheck();
                            }
                        });
                    }

                });
            }
        },
        getSessionIdsOrdered() {
            return Object.values(window.CLASS.Session)
                .sort((s1, s2) => s1.Order__c - s2.Order__c)
                .map(session => session.Id)
        },
        advanceToNextSession() {
            const orderedSessionIds = this.getSessionIdsOrdered();
            const currentSessionIndex = orderedSessionIds.indexOf(this.current_session)
            if (currentSessionIndex !== orderedSessionIds.length) {
                this.set(this.mclass.Session[orderedSessionIds[currentSessionIndex + 1]])
                setTimeout(() => {
                    this.player = new Player(this.$refs.iframe)
                    this.player.play()
                }, 1000)
            }
        },
        completeCheck() {
            // const self = this
            this.player.getCurrentTime().then((seconds) => {
                // Update Current Position
                if(typeof this.mclass.Session[this.current_session].Status.Status_JSON__c != 'undefined') {
                    const pos = seconds;
                    const duration = this.mclass.Session[this.current_session].Status.Status_JSON__c.duration;
                    const completion_pct = pos / duration;

                    if(completion_pct > 0.8 && !this.completed_sessions.includes(this.current_session)) {
                        this.completed_sessions.push(this.current_session);

                        apiCall('/session/sessionComplete/'+this.current_session,'POST',{
                            class_id: this.mclass.Id,
                            student: this.mclass.Student
                        })
                        .then( (e) => {
                            return e.json();
                        })
                        .then((data)=>{
                            if(data.class_complete){
                                this.complete();
                            }
                        });
                    }
                }
            });
        },
        set(session) {
            this.preview = false;
            if(this.mclass.enrolled){

                this.sessionDetails(session);
                // const self = this

                this.player.unload().then(() => {
                    this.player.loadVideo(this.converted_urls[session.Id])
                    .then(() => {
                        this.player.getVideoId().then((id) => {

                            this.player.getDuration().then((duration) =>  {

                                if(typeof this.mclass.Session[session.Id].Status.Status_JSON__c != 'undefined'){
                                    if(this.mclass.Session[session.Id].Status.Status_JSON__c.position == null){
                                        this.mclass.Session[session.Id].Status.Status_JSON__c.position = 0
                                    }
                                    this.player.setCurrentTime(this.mclass.Session[session.Id].Status.Status_JSON__c.position);
                                }

                                apiCall('/session/start/'+session.Id,'POST',{
                                    position: 1,
                                    duration,
                                    class_id: this.mclass.Id,
                                    student: this.mclass.Student
                                })
                                .then( (e) => {
                                    return e.json();
                                })
                                .then((data)=>{
                                        var pos = 0;

                                        if(typeof data.Status.Status_JSON__c != 'undefined'){
                                            pos = data.Status.Status_JSON__c.position;
                                            this.last_position = pos;
                                        }

                                        if(pos > 0){
                                            this.player.setCurrentTime(pos);
                                        }

                                        if(typeof data.Status.Status_JSON__c == 'undefined'){
                                            this.player.getDuration().then(function(dur){
                                                // data.Status.Status_JSON__c = {
                                                //     duration: dur,
                                                //     position: 0
                                                // }
                                                this.mclass.Session[session.Id].Status.Status_JSON__c = {
                                                    duration: dur,
                                                    position: 0
                                                }; 
                                            })
                                        } else {
                                            this.mclass.Session[session.Id].Status = data.Status; 
                                        }
                                });
                            });

                            this.loading = true;
                            this.current_session = session.Id
                            if(id != this.converted_urls[session.Id]){
                                this.player.unload().then(() => {
                                    this.player.loadVideo(this.converted_urls[session.Id]);
                                })
                            } else {
                                console.warn('Same Video')
                                setTimeout(() => {
                                    this.loading = false;
                                },1250);
                            }
                        });
                    })
                })
            } else {
                this.needs_login = session.Id;
            }
        },
        // Simple API to Vimeo to get ID
        // Source: https://stackoverflow.com/questions/13286785/get-video-id-from-vimeo-url/13286930
        // Author: l2aelba
        GetVimeoIDbyUrl(url) {
            var id = false;
            var request = new XMLHttpRequest();
            request.open('GET', 'https://vimeo.com/api/oembed.json?url='+url , false);
            request.onload = function() {
                if (request.status >= 200 && request.status < 400) {
                    var response = JSON.parse(request.responseText);
                    if(response.video_id) {
                        id = response.video_id;
                    }
                }
            };
            request.send();
            return id;
        },
        setEmail(value){
            this.email = value
        },
        setZip(value){
            this.zip = value
        },
        login(){
            //const self = this;
            const session_id = this.needs_login;
            this.needs_login = false;
            this.loading = true;

            apiCall('/auth/login','POST',{email:this.email,zip:this.zip,class_id:this.mclass.Id})
            .then((resp)=>{
                return resp.json();
            })
            .then((data)=>{
                if (data.error == 0 ){
                    this.isEnrolled(data.data,session_id);
                    document.getElementById('LogoutLink').classList.remove('d-none');
                    this.mclass.auth = true
                    this.ac_opts = JSON.stringify({
                        email: this.email,
                        zip: this.zip,
                        directForm: true
                    })
                    this.mclass.Student = data.data.Student[0]
                }
                if(!this.mclass.enrolled) {
                    this.mclass.needs_register = true;
                    this.loading = false;
                }
            });
        },
        isEnrolled(data,session_id) {
            data.Student.forEach( (e) => {
                if(this.mclass.Id == e.Class__c) {
                    this.mclass.needs_register = false;
                    this.mclass.enrolled = true;
                    this.set({Id:session_id});
                }
            })
        },

        appCoreObserver() {
            // Select the node that will be observed for mutations
            const targetNode = document.querySelector('head');

            // Options for the observer (which mutations to observe)
            const config = { attributes: true, childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            const callback = function(mutationsList) { // eslint-disable-line no-use-before-define
                // Use traditional 'for loops' for IE 11
                for(let mutation of mutationsList) {
                    if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].nodeName == 'STYLE') {
                        // console.log(mutation)
                        // console.log('A child node has been added or removed.');
                    }
                    else if (mutation.type === 'attributes') {
                        // console.log('The ' + mutation.attributeName + ' attribute was modified.');
                    }
                }
            };

            // Create an observer instance linked to the callback function
            const observer = new MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }

    }
}
</script>
